import { api } from "@/api"
import type { TableOrdering } from "@/components/BaseTable.vue"
import type {
  PaginatedResponse,
  PaginationQuery,
} from "@/utils/utilityTypes"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

export type ListCashierGratuityStatsResponseItem = {
  cashierUsername: string
  gratuityReceived: number
  averageGratuityPercentage: number
  serviceChargeTaken: number
}

export type ListCashierGratuityStatsFilter = Pick<
  ListCashierGratuityStatsQuery,
  "search"
>

export type ListCashierGratuityStatsOrdering =
  | "cashierUsername"
  | "gratuityReceived"
  | "averageGratuityPercentage"
  | "serviceChargeTaken"

type ListCashierGratuityStatsQuery = {
  search?: string
  ordering?: TableOrdering<ListCashierGratuityStatsOrdering>
} & PaginationQuery

const listCashierGratuityStats = async (
  query?: ListCashierGratuityStatsQuery
) => {
  const { body } = await api.get<
    PaginatedResponse<ListCashierGratuityStatsResponseItem>
  >("/reports/gratuity/cashiers/", { query: query })

  return body
}

export const useCashierGratuityStats = (
  query?: MaybeRef<ListCashierGratuityStatsQuery>
) =>
  useQuery({
    queryKey: [
      BASE_GRATUITY_CASHIER_REPORT_QUERY_KEY,
      query,
    ] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listCashierGratuityStats(query_),
    keepPreviousData: true,
  })
